import _defineProperty from '@babel/runtime/helpers/defineProperty';
import LANG from '../lang.js';
import enCA from './en_CA.js';
import frCA from './fr_CA.js';

var _LANG$EN_CA$LANG$FR_C;
var i18n = (_LANG$EN_CA$LANG$FR_C = {}, _defineProperty(_LANG$EN_CA$LANG$FR_C, LANG.EN_CA, enCA), _defineProperty(_LANG$EN_CA$LANG$FR_C, LANG.FR_CA, frCA), _LANG$EN_CA$LANG$FR_C);

export default i18n;
